var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('FlashMessage'),_c('app-header'),_c('router-view'),_c('app-footer'),_c('cart-pill')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }